/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ page: NonNullable<unknown>, totalPages: NonNullable<unknown> }} Api_Keys_Table_Page_OfInputs */



/**
* | output |
* | --- |
* | "Page {page} of {totalPages}" |
*
* @param {Api_Keys_Table_Page_OfInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const api_keys_table_page_of = /** @type {((inputs: Api_Keys_Table_Page_OfInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Keys_Table_Page_OfInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Seite ${i?.page} von ${i?.totalPages}`)
	return /** @type {LocalizedString} */ (`Page ${i?.page} of ${i?.totalPages}`)
});